import React from 'react';
import styled from 'styled-components';

const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 2;
  background-color: rgba(152, 152, 152, 0.5);
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const OverlayContent = styled.div`
  background-color: ${({ theme }) => theme.colors.WHITE};
  position: fixed;
  top: 45vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 3rem;
  margin: 1.5rem;
`;

export function FormOverlay({ children }: React.PropsWithChildren<{}>) {
  return (
    <OverlayContainer>
      {children && <OverlayContent>{children}</OverlayContent>}
    </OverlayContainer>
  );
}
